"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.noToken = exports.rootToken = exports.paymentEngineToken = exports.mediaUploadToken = exports.userToken = exports.clientToken = exports.unwrapEnvelope = exports.authorisedBaseQuery = void 0;
var query_1 = require("@reduxjs/toolkit/query");
var user_1 = require("../reducers/slices/user/user");
var clientToken = function (state) { return state.userState.client_token; };
exports.clientToken = clientToken;
var userToken = function (state) { return state.userState.token; };
exports.userToken = userToken;
var mediaUploadToken = function (state) { return state.userState.media_upload_token; };
exports.mediaUploadToken = mediaUploadToken;
// sign in returns this alongside the other tokens and main.tsx rehydrates it, so it is ready before the client record is fetched
var paymentEngineToken = function (state) { return state.userState.payment_engine_token; };
exports.paymentEngineToken = paymentEngineToken;
var rootToken = function () { return process.env.LETS_TRADE_ROOT_TOKEN; };
exports.rootToken = rootToken;
var noToken = function () { return undefined; };
exports.noToken = noToken;
var unwrapEnvelope = function (response) { return response === null || response === void 0 ? void 0 : response.content; };
exports.unwrapEnvelope = unwrapEnvelope;
// the services reject empty query values, and the axios layer this replaced dropped them, so blanks must not be serialised
var withoutBlankParams = function (args) {
    if (typeof args === "string" || !args.params)
        return args;
    var params = Object.fromEntries(Object.entries(args.params).filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null && value !== "";
    }));
    return __assign(__assign({}, args), { params: params });
};
var authorisedBaseQuery = function (baseUrl, defaultToken) {
    if (defaultToken === void 0) { defaultToken = clientToken; }
    return function (args, api, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var selectToken, sentToken, fetchWithAuth, result, isCurrentSession, envelope;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    selectToken = (_a = extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.token) !== null && _a !== void 0 ? _a : defaultToken;
                    sentToken = selectToken(api.getState());
                    fetchWithAuth = (0, query_1.fetchBaseQuery)({
                        baseUrl: baseUrl,
                        prepareHeaders: function (headers) {
                            if (sentToken)
                                headers.set("authorization", "Bearer ".concat(sentToken));
                            return headers;
                        },
                    });
                    return [4 /*yield*/, fetchWithAuth(withoutBlankParams(args), api, extraOptions)];
                case 1:
                    result = _d.sent();
                    isCurrentSession = Boolean(sentToken) && sentToken === selectToken(api.getState());
                    // no refresh token is issued at sign-in, so an expired session can only be ended, never renewed
                    if (((_b = result.error) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                        if (isCurrentSession)
                            api.dispatch((0, user_1.clearSession)());
                        return [2 /*return*/, result];
                    }
                    envelope = result.data;
                    // the services answer 200 with success:false, which has to surface as an error so hooks never treat a failure as data
                    if (envelope && envelope.success === false) {
                        return [2 /*return*/, {
                                error: {
                                    status: "CUSTOM_ERROR",
                                    error: (_c = envelope.message) !== null && _c !== void 0 ? _c : "The request was unsuccessful.",
                                    data: envelope,
                                },
                            }];
                    }
                    return [2 /*return*/, result];
            }
        });
    }); };
};
exports.authorisedBaseQuery = authorisedBaseQuery;
